import React, { useMemo, useEffect, useState, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
// Components
import Button from "../../../../components/buttons/buttons";
import Table from "../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../components/skeleton/table";
import TableFilter from "../../../../components/tables/tableFilter";
import { Beat } from "../../../../plugins/spinners.plugin";
import EmptyState from "../../../../assets/images/emptyState/user.svg";
import { Pagination } from "../../../../components/pagination/pagination";
import { AllFiltersModal } from "../../../../components/modals/allFiltersModal";
import FilterUsersDropDown from "../../../../components/dropDown/filter/filterUsers";
import { writeFileWithXLSX } from "../../../../components/exports/xlsx";
// Actions
import {
  searchUsersAction,
  filterUsersAction,
  getAllUsersNoPagination,
} from "../../../../redux/users/userActions";
import userType from "../../../../redux/users/userTypes";

export default function AllUsers() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { page } = useParams();
  const [data, setData] = useState([]);
  const { allUsers } = useSelector((state) => state.user);

  let lastMonth = new Date();
  lastMonth.setDate(lastMonth.getDate() - 30);

  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const { filtering, searching } = useSelector((state) => state.user);
  const { downloading } = useSelector((state) => state.user);
  const [input, setInput] = useState({
    search: "",
  });

  const [payLoad] = useState({
    // start_date: lastMonth,
    end_date: new Date(),
  });

  useEffect(() => {
    if (page) {
      dispatch(filterUsersAction(payLoad, page));
    }
    // eslint-disable-next-line
  }, [page]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((user, index) => {
        let show = {
          id: index + 1,
          name: user?.name,
          email: user?.email,
          created: (
            <span>{moment(user?.created_at).format("MMM DD, YYYY")}</span>
          ),
          phone_number: (
            <span>{user?.phone ? user?.phone : "Not available"}</span>
          ),
          user: user,
        };
        outputArray.push({ show });
        return true;
      });
      return outputArray;
    }
  }

  function createTableDataDownload(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((user, index) => {
        let show = {
          id: index + 1,
          name: user?.name,
          email: user?.email,
          created: moment(user?.created_at).format("MMM DD, YYYY"),
          phone_number: user?.phone,
        };
        outputArray.push(show);
        return true;
      });
      return outputArray;
    }
  }

  useLayoutEffect(() => {
    const dataSet = createTableData(allUsers?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allUsers]);

  function goToSinglePage(params) {
    let user_id = params?.show?.user?.id;
    navigate(`/admin/users/details/${user_id}`, {
      state: { user: params?.show?.user },
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
    setIsSearchOpen(true);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allUsers?.data);
      setData(dataSet);
      setIsSearchOpen(false);
      dispatch({
        type: userType["SEARCH_USERS"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchUsersAction(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const handleDownload = async () => {
    const response = await dispatch(
      getAllUsersNoPagination({
        ...payLoad,
        pagination: 0,
      })
    );
    if (response) {
      const newData = createTableDataDownload(response?.data);
      writeFileWithXLSX(newData, {
        filename: "All_Users.xlsx",
        download: true,
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "show.id",
          },
          {
            Header: "Name",
            accessor: "show.name",
          },
          {
            Header: "Email",
            accessor: "show.email",
          },
          {
            Header: "Created On",
            accessor: "show.created",
          },
          {
            Header: "Phone Number",
            accessor: "show.phone_number",
          },
        ],
      },
    ],
    []
  );
  return (
    <div data-test="users-page">
      <TableFilter
        title={"Users"}
        results={allUsers?.to}
        totalResults={allUsers?.total}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterUsersDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
        searchPlaceholder={"Name or Email"}
      >
        <Button.Secondary
          title={downloading ? <Beat color={"#CE2600"} /> : "Download CSV"}
          onClick={handleDownload}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="py-24 text-center">
            <div className="flex justify-center">
              <img src={EmptyState} className="w-auto" alt="no data" />
            </div>
            <h3 className="mt-5 text-xl font-bold">Users</h3>
            <p className="mt-2 text-sm text-[#9CA3AF]">
              You do not have any users yet.
            </p>
          </div>
        )}
      </div>

      {!isSearchOpen && (
        <Pagination data={allUsers} route={"admin/users/all"} />
      )}
    </div>
  );
}
